import React, { useContext, useState } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import { UserContext } from "../../contexts/UserContext";
import { Button } from "../../components/ui/forms/Button";
import BigButton from "../../components/Photos/BigButton";
import { PatronContext } from "../../contexts/PatronContext";
import { PaneContext } from "../../contexts/PaneContext";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";

const PhotoUpload = () => {
  const { patron, uploadPhoto } = useContext(PatronContext);
  const { previewPanePhoto, updatePreviewPane } = useContext(PaneContext);
  const { apiUrl } = useContext(DatabaseContext);
  const { Site, getMe } = useContext(UserContext);

  const [photoData, setPhotoData] = useState(null);

  const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const onDrop = (files) => {
    const img = files[0];
    setPhotoData(img);
    getBase64(img, (result) => {
      updatePreviewPane(result);
    });
  };

  const undo = () => {
    setPhotoData(null);
    updatePreviewPane("");
  };

  const save = async () => {
    try {
      await uploadPhoto(patron.externalID, photoData);
      patron.hasPhoto = 1;

      updatePreviewPane(previewPanePhoto);
    } catch (error) {
      console.error("Upload failed", error);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
    },
    multiple: false,
  });

  return (
    <BigButton
      {...getRootProps()}
      icon={<AddPhotoAlternateIcon style={iconStyles} />}
      colour="success"
      variant="upload"
      isUpload
    >
      <>
        {photoData != undefined ? (
          <Buttons>
            <Button onClick={undo} colour="error" margin="0 1rem 0 0">
              Undo
            </Button>
            <Button colour="success" onClick={save}>
              Save
            </Button>
          </Buttons>
        ) : (
          <div>
            <input type="file" {...getInputProps()} />
            Click here to select file
          </div>
        )}
      </>
    </BigButton>
  );
};

const iconStyles = {
  fontSize: "110px",
  marginLeft: "80px",
};

const Buttons = styled.div`
  display: flex;
`;

export default PhotoUpload;
